document.addEventListener('DOMContentLoaded', function () {
  const accordions = document.querySelectorAll('.product__accordion details');

  accordions.forEach(function (details) {
    const summary = details.querySelector('summary');

    summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');

    details.addEventListener('toggle', function () {
      if (details.open) {
        accordions.forEach(function (otherDetails) {
          if (otherDetails !== details) {
            otherDetails.removeAttribute('open');

            const otherSummary = otherDetails.querySelector('summary');
            if (otherSummary) {
              otherSummary.setAttribute('aria-expanded', 'false');
            }
          }
        });
      }

      summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
    });
  });
});